"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryByLanguage = getCountryByLanguage;
exports.getDefaultCountryByUser = getDefaultCountryByUser;
exports.default = exports.COUNTRY_CODE = exports.ALL_COUNTRIES = exports.COUNTRY = void 0;

var _users = require("./users");

// CONSTANTS
var COUNTRY = {
  ANDORRA: 'ANDORRA',
  AUSTRIA: 'AUSTRIA',
  BELGIUM: 'BELGIUM',
  BOLIVIA: 'BOLIVIA',
  BULGARIA: 'BULGARIA',
  CROATIA: 'CROATIA',
  CZECH_REPUBLIC: 'CZECH_REPUBLIC',
  DENMARK: 'DENMARK',
  ESTONIA: 'ESTONIA',
  FRANCE: 'FRANCE',
  GERMANY: 'GERMANY',
  GREECE: 'GREECE',
  HUNGARY: 'HUNGARY',
  ICELAND: 'ICELAND',
  INDIA: 'INDIA',
  ITALY: 'ITALY',
  IVORY_COAST: 'IVORY_COAST',
  LATVIA: 'LATVIA',
  LITHUANIA: 'LITHUANIA',
  LUXEMBOURG: 'LUXEMBOURG',
  MAURITIUS: 'MAURITIUS',
  MEXICO: 'MEXICO',
  MONACO: 'MONACO',
  NETHERLANDS: 'NETHERLANDS',
  POLAND: 'POLAND',
  PORTUGAL: 'PORTUGAL',
  ROMANIA: 'ROMANIA',
  SERBIA: 'SERBIA',
  SLOVAKIA: 'SLOVAKIA',
  SLOVENIA: 'SLOVENIA',
  SPAIN: 'SPAIN',
  SWEDEN: 'SWEDEN',
  SWITZERLAND: 'SWITZERLAND',
  UNITED_KINGDOM: 'UNITED_KINGDOM'
};
exports.COUNTRY = COUNTRY;
var ALL_COUNTRIES = [COUNTRY.ANDORRA, COUNTRY.AUSTRIA, COUNTRY.BELGIUM, COUNTRY.BOLIVIA, COUNTRY.BULGARIA, COUNTRY.CROATIA, COUNTRY.CZECH_REPUBLIC, COUNTRY.DENMARK, COUNTRY.ESTONIA, COUNTRY.FRANCE, COUNTRY.GERMANY, COUNTRY.GREECE, COUNTRY.HUNGARY, COUNTRY.ICELAND, COUNTRY.INDIA, COUNTRY.ITALY, COUNTRY.IVORY_COAST, COUNTRY.LATVIA, COUNTRY.LITHUANIA, COUNTRY.LUXEMBOURG, COUNTRY.MAURITIUS, COUNTRY.MEXICO, COUNTRY.MONACO, COUNTRY.NETHERLANDS, COUNTRY.POLAND, COUNTRY.PORTUGAL, COUNTRY.ROMANIA, COUNTRY.SERBIA, COUNTRY.SLOVAKIA, COUNTRY.SLOVENIA, COUNTRY.SPAIN, COUNTRY.SWEDEN, COUNTRY.SWITZERLAND, COUNTRY.UNITED_KINGDOM];
exports.ALL_COUNTRIES = ALL_COUNTRIES;
var COUNTRY_CODE = {
  ANDORRA: 'ad',
  AUSTRIA: 'at',
  BELGIUM: 'be',
  BOLIVIA: 'bo',
  BULGARIA: 'bg',
  CROATIA: 'hr',
  CZECH_REPUBLIC: 'cz',
  DENMARK: 'dk',
  ESTONIA: 'ee',
  FRANCE: 'fr',
  GERMANY: 'de',
  GREECE: 'gr',
  HUNGARY: 'hu',
  ICELAND: 'is',
  INDIA: 'in',
  ITALY: 'it',
  IVORY_COAST: 'ci',
  LATVIA: 'lv',
  LITHUANIA: 'lt',
  LUXEMBOURG: 'lu',
  MAURITIUS: 'mu',
  MEXICO: 'mx',
  MONACO: 'mc',
  NETHERLANDS: 'nl',
  POLAND: 'pl',
  PORTUGAL: 'pt',
  ROMANIA: 'ro',
  SERBIA: 'rs',
  SLOVAKIA: 'sk',
  SLOVENIA: 'si',
  SPAIN: 'es',
  SWEDEN: 'se',
  SWITZERLAND: 'ch',
  UNITED_KINGDOM: 'gb'
}; // FUNCTIONS

exports.COUNTRY_CODE = COUNTRY_CODE;

function getCountryByLanguage(language) {
  switch (language) {
    case 'fr':
      return COUNTRY.FRANCE;

    case 'es':
      return COUNTRY.SPAIN;

    case 'it':
      return COUNTRY.ITALY;

    default:
      return COUNTRY.GERMANY;
  }
}

function getDefaultCountryByUser(user) {
  var defaultEntity = user.entities[0];

  if ((0, _users.userHasMultiEntities)(user)) {
    // We try to find the best entity to use for the given locale of the user
    if (user.language === 'fr' && user.entities.includes(_users.ENTITY.FRANCE)) {
      defaultEntity = _users.ENTITY.FRANCE;
    }

    if (user.language === 'de' && user.entities.includes(_users.ENTITY.GERMANY)) {
      defaultEntity = _users.ENTITY.GERMANY;
    }

    if (user.language === 'it' && user.entities.includes(_users.ENTITY.ITALY)) {
      defaultEntity = _users.ENTITY.ITALY;
    }
  }

  switch (defaultEntity) {
    case _users.ENTITY.FRANCE:
      return COUNTRY.FRANCE;

    case _users.ENTITY.GERMANY:
      return COUNTRY.GERMANY;

    case _users.ENTITY.ITALY:
      return COUNTRY.ITALY;

    default:
      // eslint-disable-next-line no-console
      console.error("The entity [".concat(defaultEntity, "] is not recognize for the current user id: ").concat(user.id));
      return null;
  }
}

var countryUtils = {
  COUNTRY: COUNTRY,
  ALL_COUNTRIES: ALL_COUNTRIES,
  getCountryByLanguage: getCountryByLanguage,
  getDefaultCountryByUser: getDefaultCountryByUser
};
var _default = countryUtils;
exports.default = _default;
//# sourceMappingURL=country.js.map